module.exports = __webpack_public_path__ + "assets/img/zhengshu.f7eda45e.png";